import UnloadConfirmation from 'unload_confirmation'
let userInfoUnloadConfirmation = new UnloadConfirmation()
let tabUnloadConfirmation = new UnloadConfirmation()
const CALL_CENTER_SHOW_PAGE_CLASS = '#call-center-show-page'
const MINIMIZE_CLASS = 'btn btn-tool btn-primary minimize'
const MAXIMIZE_CLASS = 'btn btn-tool btn-primary maximaize'
const TOP_CONTENT_ID = '#call-center-user-info'
const UNDER_CONTENT_ID = '#call-center-user-tab'

$(document).ready(function() {
  $('.js-select2').each(function(i, form){
    $(form).attr('id','select2-' + (i))
    $(form).select2()
  })

  // コールセンター詳細ページでなければ処理を行わない
  if($(CALL_CENTER_SHOW_PAGE_CLASS).length === 0) { return; }

  $('.content-wrapper').addClass("call_center_user_wrapper")
  SplitView.activate($("#main")[0])

  $('#minimize-button').on('click', function(){
    let is_minimize = $(this).attr('class').match(/minimize/) ? true : false;
    if(is_minimize){
      $(this).attr('class', MAXIMIZE_CLASS)
      $(this).text('最大化')
      $(TOP_CONTENT_ID).addClass('max-content')
      $(UNDER_CONTENT_ID).addClass('min-content')
      $('.gutter').addClass('gutter-disable')
    }
    else{
      $(this).attr('class', MINIMIZE_CLASS)
      $(this).text('最小化')
      $(TOP_CONTENT_ID).removeClass('max-content')
      $(UNDER_CONTENT_ID).removeClass('min-content')
      $('.gutter').removeClass('gutter-disable')
    }
  })

  addConfirmationBeforeSwitchTab()
  $('#sales_strategy_id').on('change', function(){ call_button_display(this) })
  $("#user_info_edit_button").on('click', function(event) { user_info_edit_button_event(this, event) })
  $("#custom-content-below-tasklist-tab").on('click', function (event) {
    if (!tabUnloadConfirmation.isActive()) {
      task_tab_click_event(this, event);
    } else {
      event.preventDefault(); // タブの切り替えを防ぐ
    }
  });
  $('#sales_strategy_id').on('click', function(event) { return false })
  $("[id^='without-task-']").on('click', function(event){ calling_interaction_show_button_event(this, event) })
  $("#calling-history-edit-button").on('click', function(event){ calling_interaction_edit_button_event(this, event) })
  init_task_list_content()
  init_task_list_calling_interaction_content()
})

function call_button_display(task) {
  let common_disable_flg = false;
  if ($(task).val() == "") { common_disable_flg = true; }

  $('button[name="call_num"]').each(function() {
    let disable_flg = common_disable_flg
    if ($(this).val() == ""){
      disable_flg = true;
    }
    $(this).prop( 'disabled', disable_flg );
  });
}

function user_info_edit_button_event(edit_button, event) {
  event.preventDefault()
  const url = $(edit_button).attr('href')

  $.ajax({
    type: "GET",
    url: url,
    dataType: "html"
  }).done(function (response) {
    userInfoUnloadConfirmation.enable()
    $('#call-center-user-info').html(response)
    $('#user_info_update_button').on('click', function(event) { user_info_update_button_event(this, event) })
    $("[id^='day_checkbox_']").each(function(){
      if (!$(this).prop('checked')) {
        console.log($(this).parents('.form-group').find("[id^='day_time_select_']"))
        $(this).parents('.form-group').find("[id^='day_time_select_']").prop( 'disabled', true )
      }
    })
    $("[id^='day_checkbox_']").on('click', function(){
      $(this).parents('.form-group').find("[id^='day_time_select_']").prop( 'disabled', !$(this).prop('checked') )
    })
    $('#calling_schedule_date').daterangepicker({
      autoUpdateInput: false,
      timePicker: true,
      timePicker24Hour: true,
      timePickerIncrement: 1,
      singleDatePicker: true,
      locale: {
        applyLabel: '適用する',
        cancelLabel: 'キャンセル'
      }
    }, function(date) {
      $(this.element).val(date.format('YYYY-MM-DD HH:mm'));
    });
  })
  .fail(function(jqXhr, status, error){
    console.log(status)
  })
}

function user_info_update_button_event(update_button, event) {
  event.preventDefault()
  const user_info_update_url = $(update_button).attr('href')

  $.ajax({
    type: "PUT",
    url: user_info_update_url,
    data: user_info_update_datas(),
    dataType: "html"
  }).done(function (response) {
    userInfoUnloadConfirmation.disable()
    $('#call-center-user-info').html(response)
    $('#user_info_edit_button').on('click', function(event) { user_info_edit_button_event(this, event) })
    $('#sales_strategy_id').on('change', function(){ call_button_display(this) })
  })
  .fail(function(jqXhr, status, error){
    $(`#error-message-user`).html(jqXhr.responseText)
  })
}

function user_task_edit_button_event(edit_button, event){
  event.preventDefault()
  const task_id = $(edit_button).data('task-id')
  const user_task_edit_url = $(edit_button).attr('href')
  const current_table_html = $(`#task-table-content-body-${task_id}`)[0]

  $.ajax({
    type: "GET",
    url: user_task_edit_url,
    data: { task_id: task_id },
    dataType: "html"
  }).done(function (response) {
    tabUnloadConfirmation.enable()
    $(`#task-table-content-body-${task_id}`).replaceWith(response)
    const new_task_table_body = $(`#task-table-edit-content-body-${task_id}`)
    $(`#user-task-update-confirm-button-${task_id}`).on('click', function(event) { user_task_update_confirm_button_event(this, event) })
    $(`#user-task-update-cancel-button-${task_id}`).on('click', function(event) { user_task_update_cancel_button_event(task_id, event, new_task_table_body, current_table_html) })
    init_task_list_calling_interaction_content()
    // 編集中にタブを切り替えた場合キャンセル処理を行う
    $('#custom-content-below-tab').on('show.bs.tab', function() {
      if (!tabUnloadConfirmation.isActive()) {
        user_task_update_cancel_button_event(task_id, event, new_task_table_body, current_table_html)
      }
    })
  })
  .fail(function(jqXhr, status, error){
    console.log(status)
  })
}

function user_task_update_confirm_button_event(confirm_button, event){
  event.preventDefault()
  const user_task_update_url = $(confirm_button).attr('href')
  const task_id = $(confirm_button).data('task-id')

  const user_value = $('.user_id').text()
  const admin_user_value = $(`#task-admin-user-select-${task_id}`).val()
  const memo_text_value = $(`#task-memo-text-${task_id}`).val()
  const sales_strategy_value = $(`#task-sales-strategy-select-${task_id}`).val()

  $.ajax({
    type: "PUT",
    url: user_task_update_url,
    data: {
      task_id: task_id,
      sales_strategy_id: sales_strategy_value,
      admin_user_id: admin_user_value,
      memo: memo_text_value
    },
    dataType: "html"
  }).done(function (response) {
    tabUnloadConfirmation.disable()
    $(`#task-table-edit-content-body-${task_id}`).replaceWith(response)
    $(`#task-table-content-body-${task_id}`).removeClass('d-none')
    $(`#user-task-edit-button-${task_id}`).on('click', function(event) { user_task_edit_button_event(this, event) })
    init_task_list_calling_interaction_content()
    update_task_content(task_id)
    replace_user_tasks(user_value)
  })
  .fail(function(jqXhr, status, error){
    $(`#error-message-${task_id}`).html(jqXhr.responseText)
  })
}

function user_task_update_cancel_button_event(task_id, event, target_table, beforehtml){
  event.preventDefault()
  tabUnloadConfirmation.disable()
  target_table.replaceWith(beforehtml)
  $(`#user-task-edit-button-${task_id}`).on('click', function(event) { user_task_edit_button_event(this, event) })
  init_task_list_calling_interaction_content()
}

function create_new_task_button_event(create_button, event){
  event.preventDefault()
  const url = $(create_button).attr('href')
  $('#create-new-task-button').addClass("disabled");

  $.ajax({
    type: "GET",
    url: url,
    dataType: "html"
  }).done(function (response) {
    tabUnloadConfirmation.enable()
    $('#tasklist').find('tbody').prepend(response)
    $('#new-task-table-row').attr('aria-expanded', true)
    $('#new-task-register-button').on('click', function(event) { new_task_register_button_event(this, event) })
    $('#new-task-cancel-button').on('click', function (event) { new_task_register_cancel_button(this, event) })
    // 新規登録中にタブを切り替えた場合キャンセル処理を行う
    $('#custom-content-below-tab').on('show.bs.tab', function() {
      if (!tabUnloadConfirmation.isActive()) {
        new_task_register_cancel_button(this, event)
      }
    })
  })
  .fail(function(jqXhr, status, error){
    console.log(status)
  })
}

function new_task_register_button_event(register_button, event){
  event.preventDefault()
  const new_task_register_url = $(register_button).attr('href')

  const user_value = $('.user_id').text()
  const admin_user_value = $(`#task-admin-user-select-new-task`).val()
  const memo_text_value = $(`#task-memo-text-new-task`).val()
  const sales_strategy_value = $(`#task-sales-strategy-select-new-task`).val()

  $.ajax({
    type: "PUT",
    url: new_task_register_url,
    data: {
      sales_strategy_id: sales_strategy_value,
      admin_user_id: admin_user_value,
      memo: memo_text_value
    },
    dataType: "html"
  }).done(function (response) {
    tabUnloadConfirmation.disable()
    $(`#tasklist`).replaceWith(response)
    replace_user_tasks(user_value)
    init_task_list_content()
    init_task_list_calling_interaction_content()
    $('#create-new-task-button').removeClass("disabled");
  })
  .fail(function(jqXhr, status, error){
    const html = jqXhr.responseText
    $("#error-message-new-task").html(html)
  })
}

function new_task_register_cancel_button(cancel_button, event){
  event.preventDefault()
  tabUnloadConfirmation.disable()
  $("#new-task-table-row").remove()
  $("#task-table-edit-content-body-new-task").remove()
  $('#create-new-task-button').removeClass("disabled");
}

function replace_user_tasks(user_id){
  $.ajax({
    type: "GET",
    url: "/admin/call_center/users/"+ user_id + "/user_tasks",
    dateType: "json",
    success: function(obj) {
      $('#sales_strategy_id').html(obj['replace_html'])
    }
  })
  .fail(function(jqXhr, status, error){
    console.log(status)
  })
}

function init_task_list_content(){
  $("[id^='user-task-edit-button-']").each(function(i, element){
    $(element).on('click', function(event){ user_task_edit_button_event(this, event)})
  })

  $('#create-new-task-button').on('click', function(event){ create_new_task_button_event(this, event) })
}

function init_task_list_calling_interaction_content() {
  $("[id^='calling-history-show-button-']").each(function(i, element){
    $(element).on('click', function(event) { calling_interaction_show_button_event(this, event) })
  })

  all_show_calling_interaction()
}

function calling_interaction_show_button_event(show_button, event){
  event.preventDefault()

  const calling_interaction_url = $(show_button).attr('href')
  const calling_interaction_id = $(show_button).data('calling-interaction-id')

  $.ajax({
    type: "GET",
    url: calling_interaction_url,
    data: { calling_interaction_id: calling_interaction_id },
    dataType: "html"
  }).done(function (response) {
    $('#callinghistory').replaceWith(response)
    $('#callinghistory').addClass('active show')
    $("#calling-history-edit-button").on('click', function(event){ calling_interaction_edit_button_event(this, event) })
    $("[id^='without-task-']").on('click', function(event){ calling_interaction_show_button_event(this, event) })
    $("#call_text_log_show_button").on('click', function(event) { call_text_log_show_button_event(this, event) })
    $("#custom-content-below-callinghistory-tab").trigger('click')
  })
  .fail(function(jqXhr, status, error){
    console.log(status)
  })
}

function calling_interaction_edit_button_event(edit_button, event){
  event.preventDefault()
  const calling_interaction_id = $(edit_button).data('calling-interaction-id')
  const calling_interaction_edit_url = $(edit_button).attr('href')
  const current_calling_interaction_html = $('#callinghistory')

  $.ajax({
    type: "GET",
    url: calling_interaction_edit_url,
    data: { calling_interaction_id: calling_interaction_id },
    dataType: "html"
  }).done(function (response) {
    tabUnloadConfirmation.enable()
    $('#callinghistory').replaceWith(response)
    $(`#calling-history-update-button-${calling_interaction_id}`).on('click', function(event){ calling_interaction_update_button_event(this, event) })
    $(`#calling-history-update-cancel-button-${calling_interaction_id}`).on('click', function(event){ calling_interaction_update_cancel_button_event(current_calling_interaction_html, $('#callinghistory'), event) })
    $("#call_text_log_show_button").on('click', function (event) { call_text_log_show_button_event(this, event) })
    // 編集中にタブを切り替えた場合キャンセル処理を行う
    $('#custom-content-below-tab').on('show.bs.tab', function() {
      if (!tabUnloadConfirmation.isActive()) {
        calling_interaction_update_cancel_button_event(current_calling_interaction_html, $('#callinghistory'), event)
      }
    })
  })
  .fail(function(jqXhr, status, error){
    console.log(status)
  })
}

function calling_interaction_update_button_event(update_button, event){
  event.preventDefault()
  const calling_interaction_update_url = $(update_button).attr('href')
  const calling_interaction_id = $(update_button).data('calling-interaction-id')

  const call_status_value = $(`#call-status-select-${calling_interaction_id}`).val()
  const sales_strategy_value = $(`#calling-history-sales-strategy-${calling_interaction_id}`).val()
  const content_value = $(`#calling-history-content-${calling_interaction_id}`).val()

  $.ajax({
    type: "PUT",
    url: calling_interaction_update_url,
    data: {
      calling_interaction_id: calling_interaction_id,
      call_status: call_status_value,
      sales_strategy_id: sales_strategy_value,
      content: content_value
    },
    dataType: "html"
  }).done(function (response) {
    tabUnloadConfirmation.disable()
    $('#callinghistory').replaceWith(response)
    $('#callinghistory').addClass('active show')
    $(`#calling-history-edit-button`).on('click', function(event){ calling_interaction_edit_button_event(this, event) })
    $("[id^='without-task-']").on('click', function(event){ calling_interaction_show_button_event(this, event) })
    $("#call_text_log_show_button").on('click', function(event) { call_text_log_show_button_event(this, event) })
  })
  .fail(function(jqXhr, status, error){
    $(`#error-message-${calling_interaction_id}`).html(jqXhr.responseText)
  })
}

function calling_interaction_update_cancel_button_event(before_html, target, event){
  event.preventDefault()
  tabUnloadConfirmation.disable()
  target.replaceWith(before_html)
  $("#calling-history-edit-button").on('click', function(event){ calling_interaction_edit_button_event(this, event) })
  $("[id^='without-task-']").on('click', function(event){ calling_interaction_show_button_event(this, event) })
  $("#call_text_log_show_button").on('click', function(event) { call_text_log_show_button_event(this, event) })
}

function call_text_log_show_button_event(show_button, event){
  event.preventDefault()
  const call_text_log_show_url = $(show_button).attr('href')
  const calling_interaction_id = $(show_button).data('calling-interaction-id')

  $.ajax({
    type: "GET",
    url: call_text_log_show_url,
    data: { calling_interaction_id: calling_interaction_id },
    dataType: "html"
  }).done(function (response) {
    $('#recordtext').replaceWith(response)
    $('#call-text-log-edit-button').on('click', function(event){ call_text_log_edit_button_event(this, event) })
    $('#custom-content-below-recordtext-tab').trigger('click')
  })
  .fail(function(jqXhr, status, error){
    console.log(status)
  })
}

function call_text_log_edit_button_event(edit_button, event){
  event.preventDefault()
  const call_text_log_edit_url = $(edit_button).attr('href')
  const calling_interaction_id = $(edit_button).data('calling-interaction-id')
  const current_call_text_log_html = $("#recordtext")

  $.ajax({
    type: "GET",
    url: call_text_log_edit_url,
    data: { calling_interaction_id: calling_interaction_id },
    dataType: "html"
  }).done(function (response) {
    tabUnloadConfirmation.enable()
    $('#recordtext').replaceWith(response)
    $('#call-text-log-update-button').on('click', function(event){ call_text_log_update_button_event(this, event) })
    $('#call-text-log-update-chancel-button').on('click', function (event) { call_text_log_update_chancel_button_event(current_call_text_log_html, '#recordtext', event) })
    // 編集中にタブを切り替えた場合キャンセル処理を行う
    $('#custom-content-below-tab').on('show.bs.tab', function() {
      if (!tabUnloadConfirmation.isActive()) {
        call_text_log_update_chancel_button_event(current_call_text_log_html, '#recordtext', event)
      }
    })
  })
  .fail(function(jqXhr, status, error){
    console.log(status)
  })
}

function call_text_log_update_button_event(update_button, event){
  event.preventDefault()
  const call_text_log_update_url = $(update_button).attr('href')
  const calling_interaction_id = $(update_button).data('calling-interaction-id')

  const text_log_content_list = document.getElementsByClassName('call-text-log-content-text')
  var call_text_log_content_value_ary = []
  for(let i = 0;i < text_log_content_list.length; i++) {
    call_text_log_content_value_ary.push(text_log_content_list.item(i).value);
  }

  $.ajax({
    type: "PUT",
    url: call_text_log_update_url,
    data: {
      calling_interaction_id: calling_interaction_id,
      call_text_log_content: call_text_log_content_value_ary
    },
    dataType: "html"
  }).done(function (response) {
    tabUnloadConfirmation.disable()
    $('#recordtext').replaceWith(response)
    $('#recordtext').addClass('active show')
    $("#call-text-log-edit-button").on('click', function(event){ call_text_log_edit_button_event(this, event) })
  })
  .fail(function(jqXhr, status, error){
    $(`#error-message-${calling_interaction_id}`).html(jqXhr.responseText)
  })
}

function call_text_log_update_chancel_button_event(before_html, target_id, event){
  event.preventDefault()
  tabUnloadConfirmation.disable()
  $(target_id).replaceWith(before_html)
  $('#call-text-log-edit-button').on('click', function(event){ call_text_log_edit_button_event(this, event) })
}

function all_show_calling_interaction_button_event(show_button, event){
  event.preventDefault()

  let targets = $(show_button).parents('.expandable-body').find('.view_limit')
  targets.each(function(index,element) {
    if($(element).css('display') === 'none'){
      $(element).show();
      $(show_button).text("閉じる");
    }else{
      $(element).hide();
      $(show_button).text("すべてを表示する");
    }
  });
}

function all_show_calling_interaction(){
  $(".all-show-calling-interaction").on('click', function(event) { all_show_calling_interaction_button_event(this, event) })
}

function update_task_content(task_id){
  let ss_id_name = $(`.task-content-sales_strategy_name-${task_id}`).text()
  let task_admin_user_name = $(`.task-content-admin_user_name-${task_id}`).text()

  $(`.task_sales_strategy_id_name-${task_id}`).text(`${ss_id_name}`)
  $(`.task_admin_user_name-${task_id}`).text(task_admin_user_name)
}

function task_tab_click_event(tab, event){
  const show_user_tasks_url = $(tab).data('show-url')

  $.ajax({
    type: "GET",
    url: show_user_tasks_url,
    dataType: "html"
  }).done(function (response) {
    $(`#tasklist`).replaceWith(response)
    init_task_list_content()
    init_task_list_calling_interaction_content()
  })
  .fail(function(jqXhr, status, error){
    console.log(status)
  })
}

function user_info_update_datas() {
  const calling_phone = $('#calling_phone_text').val()
  const iisianet_register_status = $('#iisia_net_select').val()
  const prometheus_info = $('#prometheus_info_select').val()
  const calling_memo = $('#calling_memo_text').val()
  const calling_admin_user = $('#calling_user_select').val()
  const calling_schedule_date = $('#calling_schedule_date').val()
  const calling_schedule_admi_user = $('#calling_schedule_user_select').val()
  const memo = $('#memo_text').val()
  const privilege_log = $('#privileg_log_text').val()
  const checklist = $('#check_list_text').val()

  const available_calling_schedules = available_calling_schedules_hash()

  return {
    calling_phone: calling_phone,
    iisianet_register_status: iisianet_register_status,
    prometheus_info: prometheus_info,
    calling_memo: calling_memo,
    calling_admin_user: calling_admin_user,
    available_calling_schedules: available_calling_schedules,
    calling_schedule_date: calling_schedule_date,
    calling_schedule_admin_user: calling_schedule_admi_user,
    memo: memo,
    privilege_log: privilege_log,
    checklist: checklist
  }
}

function available_calling_schedules_hash() {
  return {
    monday: {
      calling_date: 0,
      is_checked: $('#day_time_select_0').val() === "" ? "false" : $('#day_checkbox_0').prop("checked"),
      timeslot: $('#day_time_select_0').val()
    },
    tuesday: {
      calling_date: 1,
      is_checked: $('#day_time_select_1').val() === "" ? "false" : $('#day_checkbox_1').prop("checked"),
      timeslot: $('#day_time_select_1').val()
    },
    wednesday: {
      calling_date: 2,
      is_checked: $('#day_time_select_2').val() === "" ? "false" : $('#day_checkbox_2').prop("checked"),
      timeslot: $('#day_time_select_2').val()
    },
    thursday: {
      calling_date: 3,
      is_checked: $('#day_time_select_3').val() === "" ? "false" : $('#day_checkbox_3').prop("checked"),
      timeslot: $('#day_time_select_3').val()
    },
    friday: {
      calling_date: 4,
      is_checked: $('#day_time_select_4').val() === "" ? "false" : $('#day_checkbox_4').prop("checked"),
      timeslot: $('#day_time_select_4').val()
    },
    saturday: {
      calling_date: 5,
      is_checked: $('#day_time_select_5').val() === "" ? "false" : $('#day_checkbox_5').prop("checked"),
      timeslot: $('#day_time_select_5').val()
    },
    sunday: {
      calling_date: 6,
      is_checked: $('#day_time_select_6').val() === "" ? "false" : $('#day_checkbox_6').prop("checked"),
      timeslot: $('#day_time_select_6').val()
    }
  }
}

function addConfirmationBeforeSwitchTab() {
  $('#custom-content-below-tab').on('show.bs.tab', function (e) {
    // タブの離脱防止アラートが有効状態の場合のみ、確認ダイアログを表示
    if (tabUnloadConfirmation.isActive()) {
      const confirmationMessage = '行った変更が保存されない可能性があります。';
      if (confirm(confirmationMessage)) {
        // ユーザーが「はい」を選択した場合、tabUnloadConfirmation.disable()を実行
        tabUnloadConfirmation.disable()
      } else {
        // ユーザーがキャンセルした場合、タブ移動をキャンセル
        e.preventDefault()
      }
    }
  })
}
